import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import axios from "axios";
import Head from "next/head";
import Link from "next/link";
import { useRouter } from "next/router";
import funnel from "../styles/Funnel.module.css";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import WhereToVoteIcon from "@mui/icons-material/WhereToVote";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import CardContent from "@mui/material/CardContent";
import Paper from "@mui/material/Paper";
import Footer from "../component/footer";
import CircularProgress from "@mui/material/CircularProgress";

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const SelectButton = styled(Link)(({ theme }) => ({
  color: "#fff",
  border: "1px solid var(--primary-color)",
  fontWeight: "600",
  width: "100%",
  height: "45px",
  fontSize: "16px",
  backgroundColor: "var(--primary-color)",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textDecoration: "none",
  marginTop: "15px",
  "&:hover": {
    border: "1px solid var(--primary-color)",
    backgroundColor: "var(--dark-color)",
  },
}));

export default function SuburbDirectory() {
  const Router = useRouter();
  const [state, setState] = React.useState("");
  const [suburb, setSuburb] = React.useState([]);
  const [hOne, setHOne] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [des, setDes] = React.useState("");
  const [metaDes, setMetaDes] = React.useState("");
  const [path, setPath] = React.useState("");
  const [searchValue, setSearchValue] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const handleAlphabetClick = (alphabet) => {
    setLoading(true);
    suburb.length = 0;
    axios
      .get(`${process.env.NEXT_PUBLIC_API_BASE_URL}/property/suburb/list/v2/${state}/`, {
        params: { start_letter: alphabet },
      })
      .then((res) => {
        for (let char in res.data) {
          suburb.push({ char: char, item: res.data[char] });
        }
        setSuburb(
          suburb.filter((obj, index, arr) => {
            return arr.findIndex((o) => o.char === obj.char) === index;
          })
        );
        setLoading(false);
      })
      .catch((err) => {
        if (err.code == "ERR_NETWORK") {
          Router.push("/error/");
        }
        setLoading(true);
      });
    setSearchValue("");
  };

  const handleSearchInputChange = (event) => {
    setSearchValue(event.target.value);
  };

  const alphabetGroup = Array.from({ length: 26 }, (_, i) =>
    String.fromCharCode(65 + i)
  );

  useEffect(() => {
    const stateName = window.location.pathname
      .replaceAll("/", "")
      .replaceAll("-", " ")
      .split(" ")[0];
    setPath(
      window.location.pathname.replaceAll("/", "") ==
        `${stateName}-suburbs-directory`
    );
    setState(
      window.location.pathname
        .replaceAll("/", "")
        .replaceAll("-", " ")
        .split(" ")[0]
    );
    if (stateName == "act") {
      setTitle(
        "Find the Best Suburbs for Property Investment in Australian Capital Territory"
      );
      setMetaDes(
        "Find the best suburbs for property investment in Australian Capital Territory with AbodeFinder. Our comprehensive suburbs profile provides valuable insights into the property market, including growth rates, yields, and rental returns. Discover the most promising suburbs to invest in with our informative demographics."
      );
      setHOne(
        "Comprehensive Suburbs Profile and Investment Insights for Australian Capital Territory Property Market"
      );
      setDes(
        "AbodeFinder offers a comprehensive directory of Australian Capital Territory suburbs with informative demographic data and key property market trends. Use our easy-to-read demographics to make informed investment decisions and find the most promising suburbs for your investment strategy."
      );
    } else if (stateName == "nsw") {
      setTitle(
        "Find the Best Suburbs for Property Investment in New South Wales"
      );
      setMetaDes(
        "Find the best suburbs for property investment in New South Wales with AbodeFinder. Our comprehensive suburbs profile provides valuable insights into the property market, including growth rates, yields, and rental returns. Discover the most promising suburbs to invest in with our informative demographics."
      );
      setHOne(
        "Comprehensive Suburbs Profile and Investment Insights for New South Wales Property Market"
      );
      setDes(
        "AbodeFinder offers a comprehensive directory of New South Wales suburbs with informative demographic data and key property market trends. Use our easy-to-read demographics to make informed investment decisions and find the most promising suburbs for your investment strategy."
      );
    } else if (stateName == "nt") {
      setTitle(
        "Find the Best Suburbs for Property Investment in Northern Territory"
      );
      setMetaDes(
        "Find the best suburbs for property investment in Northern Territory with AbodeFinder. Our comprehensive suburbs profile provides valuable insights into the property market, including growth rates, yields, and rental returns. Discover the most promising suburbs to invest in with our informative demographics."
      );
      setHOne(
        "Comprehensive Suburbs Profile and Investment Insights for Northern Territory Property Market"
      );
      setDes(
        "AbodeFinder offers a comprehensive directory of Northern Territory suburbs with informative demographic data and key property market trends. Use our easy-to-read demographics to make informed investment decisions and find the most promising suburbs for your investment strategy."
      );
    } else if (stateName == "qld") {
      setTitle("Find the Best Suburbs for Property Investment in Queensland");
      setMetaDes(
        "Find the best suburbs for property investment in Queensland with AbodeFinder. Our comprehensive suburbs profile provides valuable insights into the property market, including growth rates, yields, and rental returns. Discover the most promising suburbs to invest in with our informative demographics."
      );
      setHOne(
        "Comprehensive Suburbs Profile and Investment Insights for Queensland Property Market"
      );
      setDes(
        "AbodeFinder offers a comprehensive directory of Queensland suburbs with informative demographic data and key property market trends. Use our easy-to-read demographics to make informed investment decisions and find the most promising suburbs for your investment strategy."
      );
    } else if (stateName == "sa") {
      setTitle(
        "Find the Best Suburbs for Property Investment in South Australia"
      );
      setMetaDes(
        "Find the best suburbs for property investment in South Australia with AbodeFinder. Our comprehensive suburbs profile provides valuable insights into the property market, including growth rates, yields, and rental returns. Discover the most promising suburbs to invest in with our informative demographics."
      );
      setHOne(
        "Comprehensive Suburbs Profile and Investment Insights for South Australia Property Market"
      );
      setDes(
        "AbodeFinder offers a comprehensive directory of South Australia suburbs with informative demographic data and key property market trends. Use our easy-to-read demographics to make informed investment decisions and find the most promising suburbs for your investment strategy."
      );
    } else if (stateName == "tas") {
      setTitle("Find the Best Suburbs for Property Investment in Tasmania");
      setMetaDes(
        "Find the best suburbs for property investment in Tasmania with AbodeFinder. Our comprehensive suburbs profile provides valuable insights into the property market, including growth rates, yields, and rental returns. Discover the most promising suburbs to invest in with our informative demographics."
      );
      setHOne(
        "Comprehensive Suburbs Profile and Investment Insights for Tasmania Property Market"
      );
      setDes(
        "AbodeFinder offers a comprehensive directory of Tasmania suburbs with informative demographic data and key property market trends. Use our easy-to-read demographics to make informed investment decisions and find the most promising suburbs for your investment strategy."
      );
    } else if (stateName == "vic") {
      setTitle("Find the Best Suburbs for Property Investment in Victoria");
      setMetaDes(
        "Find the best suburbs for property investment in Victoria with AbodeFinder. Our comprehensive suburbs profile provides valuable insights into the property market, including growth rates, yields, and rental returns. Discover the most promising suburbs to invest in with our informative demographics."
      );
      setHOne(
        "Comprehensive Suburbs Profile and Investment Insights for Victoria Property Market"
      );
      setDes(
        "AbodeFinder offers a comprehensive directory of Victoria suburbs with informative demographic data and key property market trends. Use our easy-to-read demographics to make informed investment decisions and find the most promising suburbs for your investment strategy."
      );
    } else if (stateName == "wa") {
      setTitle(
        "Find the Best Suburbs for Property Investment in Western Australia"
      );
      setMetaDes(
        "Find the best suburbs for property investment in Western Australia with AbodeFinder. Our comprehensive suburbs profile provides valuable insights into the property market, including growth rates, yields, and rental returns. Discover the most promising suburbs to invest in with our informative demographics."
      );
      setHOne(
        "Comprehensive Suburbs Profile and Investment Insights for Western Australia Property Market"
      );
      setDes(
        "AbodeFinder offers a comprehensive directory of Western Australia suburbs with informative demographic data and key property market trends. Use our easy-to-read demographics to make informed investment decisions and find the most promising suburbs for your investment strategy."
      );
    }
  }, []);

  if (path === false) {
    typeof window !== "undefined" && Router.push("/404/");
  } else if (path === true) {
    return (
      <>
        <Head>
          <title>{title}</title>
          <link
            rel="canonical"
            href={`https://abodefinder.com.au/${state}-suburbs-directory/`}
          ></link>
          <meta name="description" content={metaDes} />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link rel="icon" type="image/png" sizes="32x32" href="https://abodefinder.com.au/blog-static/img/favicon-32.ico"/>
        </Head>

        <div className={funnel.allFunnel} style={{ marginTop: "40px" }}>
          <div className={funnel.funnelChance}>
            <div className={funnel.funnelBody}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <div className={funnel.boxQn}>
                  <h1 className={funnel.h1Text}>{hOne}</h1>
                  <h2
                    className={funnel.h2TextFunnel}
                    style={{ marginBottom: "10px" }}
                  >
                    Discover the Most Promising Suburbs to Invest in with
                    AbodeFinder
                  </h2>
                  <p className={funnel.pText}>{des}</p>
                  <div className={funnel.alphabetBtnGroup}>
                    {alphabetGroup.map((alphabet) => (
                      <button
                        key={alphabet}
                        onClick={() => handleAlphabetClick(alphabet)}
                      >
                        {alphabet}
                      </button>
                    ))}
                  </div>

                  {loading ? (
                    <Box
                      sx={{
                        width: "100%",
                        height: "300px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <CircularProgress
                        sx={{ color: "var(--primary-color)" }}
                        size={70}
                      />
                    </Box>
                  ) : (
                    suburb.map((sub) => (
                      <div className={funnel.directoryTitleList}>
                        <div className={funnel.directoryTitleText}>
                          <Typography variant="h5">{sub.char}</Typography>
                        </div>
                        <div className={funnel.directorySuburbList}>
                          {sub.item.map((item) => (
                            <div className={funnel.suburbLinkDirectory}>
                              <Link
                                href={`/suburb/${state}/${item.suburb_name
                                  .toLowerCase()
                                  .replace(/\s+/g, "-")}-${item.postcode}/`}
                                target="_blank"
                              >
                                {item.suburb_name}
                              </Link>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </Box>
            </div>
          </div>
        </div>
        <Container sx={{ flexGrow: 12, mt: 3, mb: 10 }}>
          <Item
            variant="outlined"
            sx={(theme) => ({
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "center",
              p: 2,
              mb: 5,
              mt: 5,
              [theme.breakpoints.down("sm")]: {
                flexDirection: "column",
                width: "100%",
              },
            })}
          >
            <Item
              variant="outlined"
              sx={(theme) => ({
                width: "48%",
                height: "310px",
                mr: 2,
                mt: 1,
                mb: 1,
                [theme.breakpoints.down("md")]: {
                  width: "100%",
                  height: "auto",
                },
              })}
            >
              <CardContent
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Avatar
                  sx={{
                    width: 75,
                    height: 75,
                    backgroundColor: "var(--primary-color)",
                  }}
                >
                  <WhereToVoteIcon sx={{ fontSize: "50px" }} />
                </Avatar>
                <Typography
                  variant="subtitle1"
                  sx={{ textAlign: "center", mt: 3 }}
                >
                  Find the perfect suburb for your next property investment with
                  SuburbFinder. Get customised recommendations based on your
                  budget, public transport needs, and school preferences.
                </Typography>
                <SelectButton href="/suburb-finder/">
                  Find Your Ideal Suburb Now
                </SelectButton>
              </CardContent>
            </Item>
            <Item
              variant="outlined"
              sx={(theme) => ({
                width: "48%",
                height: "310px",
                mr: 2,
                mt: 1,
                mb: 1,
                [theme.breakpoints.down("md")]: {
                  width: "100%",
                  height: "auto",
                },
              })}
            >
              <CardContent
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Avatar
                  sx={{
                    width: 75,
                    height: 75,
                    backgroundColor: "var(--primary-color)",
                  }}
                >
                  <QueryStatsIcon sx={{ fontSize: "50px" }} />
                </Avatar>
                <Typography
                  variant="subtitle1"
                  sx={{ textAlign: "center", mt: 3 }}
                >
                  Calculate your chances of buying the perfect property with our
                  AI-powered Buying Chance Calculator. Get personalized insights
                  based on your budget and selected suburbs.
                </Typography>
                <SelectButton href="/buying-chance/">
                  Calculate Your Buying Chance Now
                </SelectButton>
              </CardContent>
            </Item>
          </Item>
        </Container>
        <Footer />
      </>
    );
  }
}
